import { createApp, ref, reactive, onMounted } from 'vue'

const app = createApp({
  setup() {
    const areaAinput = ref('')
    const areaBinput = ref('')
    const Maxcount = {
      A: 30,
      B: 30
    }
    let totalPrice = reactive({
      A: 0,
      B: 0
    })

    onMounted(() => {
      totalPrice.A = 20000 * Number(areaAinput.value.value)
      totalPrice.B = 8000 * Number(areaBinput.value.value)
    })

    const numberIncrement = (type, increment) => {
      // エリアA
      if (type === 'A') {
        if (areaAinput.value.value < Maxcount.A) {
          areaAinput.value.value = Number(areaAinput.value.value) + increment
          totalPrice.A = 20000 * Number(areaAinput.value.value)
        }
      }
      // エリアB
      if (type === 'B') {
        if (areaBinput.value.value < Maxcount.B) {
          areaBinput.value.value = Number(areaBinput.value.value) + increment
          totalPrice.B = 8000 * Number(areaBinput.value.value)
        }
      }
    }
    const numberDecrement = (type, decrement) => {
      // エリアA
      if (type === 'A') {
        if (areaAinput.value.value > 0) {
          areaAinput.value.value = Number(areaAinput.value.value) - decrement
          totalPrice.A = 20000 * Number(areaAinput.value.value)
        }
      }
      // エリアB
      if (type === 'B') {
        if (areaBinput.value.value > 0) {
          areaBinput.value.value = Number(areaBinput.value.value) - decrement
          totalPrice.B = 8000 * Number(areaBinput.value.value)
        }
      }
    }

    return { areaAinput, areaBinput, totalPrice, numberIncrement, numberDecrement }
  }
})
if (document.getElementById('stockControl')) {
  app.mount('#stockControl')
}
